var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.72998 2.50001C0.72998 2.19626 0.976224 1.95001 1.27998 1.95001H10.4441C10.7479 1.95001 10.9941 2.19626 10.9941 2.50001V10.4423C10.9941 10.746 10.7479 10.9923 10.4441 10.9923H1.27998C0.976224 10.9923 0.72998 10.746 0.72998 10.4423V2.50001ZM1.82998 3.05001V9.89228H9.89414V3.05001H1.82998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89413 5.55476C9.89413 5.251 10.1404 5.00476 10.4441 5.00476H12.8879C13.0338 5.00476 13.1737 5.0627 13.2768 5.16585L15.1097 6.99868C15.2128 7.10182 15.2707 7.24172 15.2707 7.38759V10.4423C15.2707 10.7461 15.0245 10.9923 14.7207 10.9923L10.4441 10.9923C10.1404 10.9923 9.89413 10.7461 9.89413 10.4423V5.55476ZM10.9941 6.10476V9.89231H14.1707V7.6154L12.6601 6.10476H10.9941Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.02919 10.9923C3.48941 10.9923 3.05183 11.4299 3.05183 11.9696C3.05183 12.5094 3.48941 12.947 4.02919 12.947C4.56897 12.947 5.00655 12.5094 5.00655 11.9696C5.00655 11.4299 4.56897 10.9923 4.02919 10.9923ZM1.95183 11.9696C1.95183 10.8223 2.8819 9.89228 4.02919 9.89228C5.17649 9.89228 6.10655 10.8223 6.10655 11.9696C6.10655 13.1169 5.17649 14.047 4.02919 14.047C2.8819 14.047 1.95183 13.1169 1.95183 11.9696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9715 10.9923C11.4317 10.9923 10.9941 11.4299 10.9941 11.9696C10.9941 12.5094 11.4317 12.947 11.9715 12.947C12.5113 12.947 12.9489 12.5094 12.9489 11.9696C12.9489 11.4299 12.5113 10.9923 11.9715 10.9923ZM9.89413 11.9696C9.89413 10.8223 10.8242 9.89228 11.9715 9.89228C13.1188 9.89228 14.0489 10.8223 14.0489 11.9696C14.0489 13.1169 13.1188 14.047 11.9715 14.047C10.8242 14.047 9.89413 13.1169 9.89413 11.9696Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarDelivery);
export default __webpack_public_path__ + "static/media/navbar-delivery.0c5698da8fc51a7f3467054d2ade81c3.svg";
export { ForwardRef as ReactComponent };